import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#6b7280","font-size":"14px"}
}
const _hoisted_3 = {
  key: 1,
  class: "data-settings"
}
const _hoisted_4 = {
  class: "data-field",
  style: {"max-width":"600px"}
}
const _hoisted_5 = {
  key: 0,
  class: "data-error"
}
const _hoisted_6 = {
  key: 1,
  class: "data-success"
}
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "data-title" }, "Notas Internas", -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("label", null, "Anotações (visíveis apenas para master admins)", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.internalNotes) = $event)),
              rows: "10",
              style: {"padding":"10px","border":"1.5px solid #d1d5db","border-radius":"8px","font-size":"14px","resize":"vertical","outline":"none","font-family":"inherit"}
            }, null, 512), [
              [_vModelText, $setup.internalNotes]
            ])
          ]),
          ($setup.notesError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.notesError), 1))
            : _createCommentVNode("", true),
          ($setup.notesSuccess)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.notesSuccess), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn-admin-primary",
            type: "button",
            disabled: $setup.notesSaving,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.saveNotes && $setup.saveNotes(...args)))
          }, _toDisplayString($setup.notesSaving ? 'Salvando...' : 'Salvar notas'), 9, _hoisted_7)
        ]))
  ]))
}